import { ProductAdditionalInformation } from '@interfaces/dto/product-detail.dto';

interface Props {
  productspecifics: ProductAdditionalInformation[];
}

const productSpecific = ({ productspecifics }: Props) => {
  return (
    <div className="specifics bg-white p-3 mb-3 rounded-2">
      <h5 className="title">ข้อมูลเฉพาะ</h5>
      {productspecifics.length > 0 ? (
        <table className="table table-striped">
          <tbody>
            {productspecifics.map(({ label, value }, key) => (
              <tr key={key}>
                <td>{label}</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        ''
      )}
    </div>
  );
};

export default productSpecific;
